/**
 * @param placement
 */
export default function getBasePlacement(placement) {
    return placement.split('-')[0];
}
//# sourceMappingURL=getBasePlacement.js.map